
import { useDetailsColumns, usePreviousDetailsColumns } from '#details/columns'
import { usePhotographsColumns } from '#photographs/columns'


export const useAvlColumns = () => {

    const detailsColumns = useDetailsColumns(['vessel-name', 'vessel-identifier', 'vessel-type'])
    const photoColumns = usePhotographsColumns()
    const previousDetailsColumns = usePreviousDetailsColumns()


    return <>

        {detailsColumns()}
        {photoColumns}
        {previousDetailsColumns}

    </>
}